import { Link } from "react-router-dom";
import { MapPin, Mail, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { InstallButton } from "./InstallButton";
import { PushOptIn } from "./PushOptIn";
import { NAV, INFO, PRODUCTS, SOCIAL, waLink, WHATSAPP_DISPLAY } from "../lib/site";

const Col = ({ title, children }) => (
  <div>
    <h4 className="mb-4 font-display text-lg font-bold uppercase tracking-wider text-white">{title}</h4>
    <ul className="space-y-2.5 text-sm">{children}</ul>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t-4 border-brand bg-[#344D5B] text-white">
    <div className="container-x grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.4fr]">
      <div>
        <Logo light />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/80">
          Máquinas e implementos agrícolas desenvolvidos para acompanhar a força do produtor rural.
        </p>
        <a href={waLink()} target="_blank" rel="noreferrer" className="btn-red mt-6" data-testid="footer-whatsapp-btn">
          <MessageCircle className="h-4 w-4" /> Solicitar orçamento
        </a>
        <div className="mt-6 flex flex-wrap gap-x-4 gap-y-2 text-xs font-bold uppercase tracking-wider">
          {SOCIAL.map((s) => (
            <a key={s.id} href={s.url} target="_blank" rel="noreferrer" className="text-white/85 transition-colors hover:text-white" data-testid={`footer-social-${s.id}`}>{s.label}</a>
          ))}
        </div>
      </div>
      <Col title="Navegação">
        {NAV.map((n) => (
          <li key={n.id}><Link to={n.path} className="text-white/80 transition-colors hover:text-white" data-testid={`footer-link-${n.id}`}>{n.label}</Link></li>
        ))}
      </Col>
      <Col title="Produtos">
        {PRODUCTS.map((p) => (
          <li key={p.slug}><Link to={`/produtos#${p.slug}`} className="text-white/80 transition-colors hover:text-white" data-testid={`footer-product-${p.slug}`}>{p.name}</Link></li>
        ))}
      </Col>
      <Col title="Contato">
        <li className="flex gap-2"><MessageCircle className="mt-0.5 h-4 w-4 shrink-0 text-white" />WhatsApp {WHATSAPP_DISPLAY}</li>
        <li className="flex gap-2"><Mail className="mt-0.5 h-4 w-4 shrink-0 text-white" />{INFO.email}</li>
        <li className="flex gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-white" />{INFO.endereco}, {INFO.cidade}</li>
      </Col>
    </div>
    <div className="border-t border-white/15">
      <div className="container-x flex flex-col gap-3 py-5 text-xs text-white/75 sm:flex-row sm:items-center sm:justify-between">
        <span>© 1996-2026 SOLLUS MÁQUINAS E IMPLEMENTOS AGRÍCOLAS</span>
        <span className="flex flex-wrap items-center gap-3 [&_button]:border-white/30 [&_button]:bg-transparent [&_button]:text-white [&_button]:hover:border-white [&_button]:hover:text-white"><InstallButton /> <PushOptIn /></span>
      </div>
    </div>
  </footer>
);
